<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-if="resize" color="primary" dark v-bind="attrs" v-on="on">
        {{ $t('rooms.newRoom') }}
        <v-icon class="ml-3">videocam</v-icon>
      </v-btn>

      <v-btn v-else color="primary" fab small dark v-bind="attrs" v-on="on">
        <v-icon>add</v-icon>
      </v-btn>
    </template>
    <FormOfRoom :dialog="dialog" v-on:close-dialog="close" />
  </v-dialog>
</template>

<script>
import FormOfRoom from '@/components/rooms/form/FormOfRoom.vue'

export default {
  data: vm => ({
    dialog: false,
    resize: null
  }),

  created() {
    this.changeButtonView()
    window.addEventListener('resize', () => this.changeButtonView())
  },

  components: {
    FormOfRoom
  },

  methods: {
    close() {
      this.dialog = false
    },
    changeButtonView() {
      const width = document.body.clientWidth
      this.resize = width > 500
    }
  }
}
</script>
